import { useState } from "react";

const ProfileImage = ({ src, alt = "プロフィール画像", className = "", fallbackText = "?" }) => {
	const [hasError, setHasError] = useState(false);
	const [isLoading, setIsLoading] = useState(true);

	const handleError = () => {
		console.warn(`Failed to load image: ${src}`);
		setHasError(true);
		setIsLoading(false);
	};

	const handleLoad = () => {
		setIsLoading(false);
	};

	// 画像URLがない場合や、エラーが発生した場合のフォールバック
	if (!src || hasError) {
		return (
			<div
				className={`flex items-center justify-center bg-gray-300 text-white font-bold ${className}`}
			>
				{fallbackText}
			</div>
		);
	}

	return (
		<div className={`relative ${className}`}>
			{isLoading && (
				<div className="absolute inset-0 flex items-center justify-center bg-gray-200 animate-pulse rounded-full">
					<div className="w-4 h-4 border-2 border-gray-400 border-t-transparent rounded-full animate-spin"></div>
				</div>
			)}
			<img
				src={src}
				alt={alt}
				className={`w-full h-full object-cover rounded-full ${isLoading ? "opacity-0" : "opacity-100"} transition-opacity duration-200`}
				onError={handleError}
				onLoad={handleLoad}
				loading="lazy"
				referrerPolicy="no-referrer"
			/>
		</div>
	);
};

export default ProfileImage;
